import { InitOptions } from "i18next";

import { USER_LOCALE_COOKIE } from "~/utils/locale";

import * as locales from "../locales";

const config: InitOptions = {
  resources: { ...locales },
  fallbackLng: { default: ["pt"] },
  lng: "pt",
  supportedLngs: ["pt", "en", "es"],
  load: "languageOnly",
  detection: {
    order: ["cookie"],
    lookupCookie: USER_LOCALE_COOKIE,
    caches: [],
  },
  interpolation: {
    escapeValue: false,
  },
};

export default config;
